var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 44,
    viewBox: "0 0 37 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.33337 7.20868V25.5778C4.33337 28.2526 5.67017 30.7504 7.89577 32.2342L18.3334 39.1926L28.771 32.2342C30.9966 30.7504 32.3334 28.2526 32.3334 25.5778V7.20868L18.3334 4.09758L4.33337 7.20868ZM1.89951 3.65196L18.3334 0L34.7672 3.65196C35.6824 3.85532 36.3334 4.66694 36.3334 5.60434V25.5778C36.3334 29.59 34.3282 33.3368 30.9898 35.5624L18.3334 44L5.67697 35.5624C2.33859 33.3368 0.333374 29.59 0.333374 25.5778V5.60434C0.333374 4.66694 0.984434 3.85532 1.89951 3.65196ZM18.3334 25L12.4555 28.0902L13.5781 21.545L8.82281 16.9098L15.3944 15.9549L18.3334 10L21.2724 15.9549L27.844 16.9098L23.0886 21.545L24.2112 28.0902L18.3334 25Z",
    fill: "url(#paint0_linear_25532_2035)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25532_2035",
    x1: 0.333374,
    y1: 0,
    x2: 24.8053,
    y2: 40.0449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD2BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.4b78b2ed34e186b2c87015e9913fb887.svg";
export { ForwardRef as ReactComponent };